var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _circle2, _path12, _circle3, _circle4, _path13, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureGrowBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.6 34.8996C66.3 35.5996 64.9 36.0996 63.3 36.0996C61.2 36.0996 59.2 35.2996 57.7 33.9996C56.2 32.6996 55.2 30.7996 54.9 28.6996L54.6 26.2996L52 5.09961H63.2C64.5 5.09961 65.7 5.99961 66 7.19961L71.8 26.9996V27.5996C71.7 30.7996 70.1 33.4996 67.6 34.8996Z",
    stroke: "#2C3549",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1 5.09961V27.2996C37.1 32.0996 33.2 36.0996 28.3 36.0996C23.4 36.0996 19.5 32.0996 19.5 27.2996C19.5 26.8996 19.5 26.5996 19.6 26.1996L22.2 5.09961H37.1Z",
    stroke: "#2C3549",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 28.6C18.6 30.7 17.6 32.6 16.1 33.9C14.6 35.2 12.6 36 10.5 36C8.9 36 7.5 35.6 6.2 34.8C3.7 33.3 2 30.6 2 27.5V26.9L7.8 7.1C8.2 5.8 9.3 5 10.6 5H21.8",
    stroke: "#2C3549",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5999 27.3994C54.5999 32.1994 50.6999 36.1994 45.7999 36.1994C41.7999 36.1994 38.4999 33.4994 37.3999 29.8994",
    stroke: "#2C3549",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1001 5.09961H52.0001",
    stroke: "#2C3549",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42 67.3L56.5 48.5L69.3 66.5L77.6 55.2",
    stroke: "#06ADEF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42 76L50 65.5V79.5H42V76Z",
    fill: "#06ADEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64.3975L56.5 57.5L59 61.5V79.5002H51V64.3975Z",
    fill: "#06ADEF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60 63L68 74.5V79.5001H60V63Z",
    fill: "#06ADEF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69 75L77 64.5V79.4993H69V75Z",
    fill: "#06ADEF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7598 59.5576L79.2704 52.7179C79.1529 52.1783 78.6201 51.8361 78.0805 51.9536L71.2408 53.443",
    stroke: "#06ADEF",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 53.5,
    r: 2,
    fill: "#06ADEF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.75,
    cy: 59.5,
    r: 2,
    fill: "#06ADEF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 35.5V49.5",
    stroke: "#2C3549",
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 70.5,
    r: 2,
    fill: "#2C3549"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 49.5,
    r: 2,
    fill: "#2C3549"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6 35.5V69.5C6 70.0523 6.44772 70.5 7 70.5H36",
    stroke: "#2C3549",
    strokeWidth: 4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 44,
    width: 17,
    height: 13,
    rx: 2,
    stroke: "#2C3549",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureGrowBusiness);
export default __webpack_public_path__ + "static/media/feature-grow-business.1cd9cf84.svg";
export { ForwardRef as ReactComponent };